function getRoutes() {
	// TODO: set base from environment
	const base = (window.location.hostname.includes('selux.com')) ? '/configurators/' : '/';
	return [
		{
			name: 'key',
			pattern: base + ':uid'
		},
		{
			name: 'key2',
			pattern: base + '/:uid'
		},
		{
			name: 'home',
			pattern: base + ':region/:language/:family',
			data: {title: 'Home'}
		},
		{
			name: 'media',
			pattern: base + ':region/:language/:family/:media',
			data: {title: 'Media'}
		},
		{
			name: 'mode',
			pattern: base + ':region/:language/:family/:media/:mode',
			data: {title: 'Mode'}
		},
		{
			name: 'configuration',
			pattern: base + ':region/:language/:family/:media/:mode/:uid'
		}, {
			name: 'not-found',
			pattern: '*'
		}
	];
}

export default getRoutes;
